import React, { useEffect, useState } from "react";
import { Link, Link as RouterLink } from "react-router-dom";
import { useSelector } from "react-redux";
import { BsChevronDown, BsList, BsX } from "react-icons/bs";
import { userlogo, headerLogo } from "../../../assets/images/index";
import ProfileMenu from "components/includes/ProfileMenu/ProfileMenu";
import { RootState } from "store/rootReducer";
import {
  NavItem,
  navbarConfig,
  getVisibleNavbar,
  setAuthState,
} from "../Navbar/navConfig";
import { Box } from "@chakra-ui/react";

const Header: React.FC = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const { isAuthenticated } = useSelector((s: RootState) => s.user);

  // const handleLogout = () => {
  //   navigate("/logout");
  // };
  const [scrolled, setScrolled] = useState(false);
  const [openMenuId, setOpenMenuId] = useState<string | null>(null);

  useEffect(() => {
    setAuthState(!!isAuthenticated);
  }, [isAuthenticated]);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Lock body scroll when mobile menu is open
  useEffect(() => {
    if (mobileMenuOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [mobileMenuOpen]);

  const visibleNav = getVisibleNavbar(navbarConfig);

  return (
    <>
      <Box
        as="header"
        className={` shadow-md fixed top-0 left-0 right-0 z-50 transition-all duration-300 border-b
        ${
          scrolled
            ? "bg-white backdrop-blur-md shadow-sm border-gray-200"
            : "bg-white border-transparent"
        }`}
      >
        <div
          className={`transition-all duration-300 ${
            scrolled ? "h-[60px]" : "h-[64px]"
          }`}
        >
          <div className="h-full max-w-screen-xl mx-auto px-4 sm:px-6 flex items-center justify-between">
            <RouterLink
              to="/"
              // className="flex-shrink-0 relative z-50 flex items-center"
              className="flex-shrink-0 relative z-50 flex items-center
              items-center hover:shadow-blue-500/35 hover:-translate-y-[1px] transition-all duration-300"
              aria-label="Go to home"
            >
              <img
                src={headerLogo}
                alt="CashQuin"
                className={`w-auto object-contain ml-2 transition-transform duration-300 hover:scale-[1.03] h-12 md:h-16`}
              />
            </RouterLink>

            {/* Desktop Navigation */}
            <nav className="hidden md:flex items-center">
              <ul className="flex items-center gap-1">
                {visibleNav.map((item) => (
                  <DesktopMenuItem key={item.id} item={item} />
                ))}
              </ul>
            </nav>

            {/* Right Actions */}
            <div className="hidden md:flex items-center gap-5">
              <div className="flex items-center gap-5 text-sm font-medium text-gray-600">
                <Link
                  to="/contactUs"
                  className="hover:text-blue-600 transition-colors relative group"
                >
                  Contact Us
                  <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-blue-600 transition-all duration-300 group-hover:w-full" />
                </Link>
                <Link
                  to="/aboutUs"
                  className="hover:text-blue-600 transition-colors relative group"
                >
                  About Us
                  <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-blue-600 transition-all duration-300 group-hover:w-full" />
                </Link>
              </div>

              <div className="pl-5 border-l border-gray-200">
                {isAuthenticated ? (
                  <div className="ml-1">
                    <ProfileMenu value="profile" />
                  </div>
                ) : (
                  <RouterLink
                    to="/auth"
                    className="group flex items-center gap-2 px-4 py-2 rounded-full bg-gradient-to-r from-blue-600 to-purple-600 text-white text-sm font-semibold shadow-md shadow-blue-500/20 hover:shadow-blue-500/35 hover:-translate-y-[1px] transition-all duration-300"
                  >
                    <img
                      src={userlogo}
                      alt="user"
                      className="w-5 h-5 rounded-full bg-white/20 p-0.5"
                    />
                    Login / Sign Up
                  </RouterLink>
                )}
              </div>
            </div>

            {/* Mobile Actions */}
            <div className="flex md:hidden items-center gap-2">
              {isAuthenticated && <ProfileMenu value="profile" />}
              {/* Mobile Menu Toggle */}
              <button
                className="relative z-50 p-2 text-gray-700 hover:text-blue-600 transition-colors"
                onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                aria-label="Toggle menu"
              >
                {mobileMenuOpen ? <BsX size={30} /> : <BsList size={30} />}
              </button>
            </div>
          </div>
        </div>

        {/* Mobile Menu Overlay */}
        <div
          className={`fixed inset-0 bg-white z-40 md:hidden transition-transform duration-300 ease-in-out ${
            mobileMenuOpen ? "translate-x-0" : "translate-x-full"
          }`}
          style={{ top: "0" }}
        >
          <div className="flex flex-col h-full pt-20 px-6 pb-8 overflow-y-auto">
            <ul className="space-y-6">
              {visibleNav.map((item) => (
                <li key={item.id}>
                  {item.children?.length ? (
                    <MobileMenuItem
                      item={item}
                      isOpen={openMenuId === item.id}
                      onToggle={() =>
                        setOpenMenuId(openMenuId === item.id ? null : item.id)
                      }
                      onTap={() => setMobileMenuOpen(false)}
                    />
                  ) : (
                    <RouterLink
                      to={item.path ?? "#"}
                      className="text-2xl font-semibold text-gray-800 hover:text-blue-600 block"
                      onClick={() => setMobileMenuOpen(false)}
                    >
                      {item.label}
                    </RouterLink>
                  )}
                </li>
              ))}
            </ul>

            <div className="mt-auto pt-8 border-t border-gray-100 flex flex-col gap-4">
              <Link
                to="/contactUs"
                className="text-lg font-medium text-gray-600"
                onClick={() => setMobileMenuOpen(false)}
              >
                Contact Us
              </Link>
              <Link
                to="/aboutUs"
                className="text-lg font-medium text-gray-600"
                onClick={() => setMobileMenuOpen(false)}
              >
                About Us
              </Link>

              {!isAuthenticated && (
                <RouterLink
                  to="/auth"
                  onClick={() => setMobileMenuOpen(false)}
                  className="flex justify-center items-center gap-2 w-full py-3 rounded-xl bg-blue-600 text-white font-semibold mt-4"
                >
                  Login / Sign Up
                </RouterLink>
              )}
            </div>
          </div>
        </div>
      </Box>
    </>
  );
};

// ---------------- Helper Components ----------------

const DesktopMenuItem: React.FC<{ item: NavItem }> = ({ item }) => {
  const hasChildren = item.children && item.children.length > 0;

  if (hasChildren) {
    return (
      <li className="relative group px-2 py-2">
        <button className="flex items-center gap-1.5 text-[13.5px] font-semibold text-gray-700 group-hover:text-blue-600 transition-colors">
          {item.label}
          <BsChevronDown className="w-3 h-3 transition-transform duration-300 group-hover:rotate-180 text-gray-400 group-hover:text-blue-600" />
        </button>

        {/* Dropdown */}
        <div className="absolute top-full left-0 w-56 pt-2 opacity-0 translate-y-2 pointer-events-none group-hover:opacity-100 group-hover:translate-y-0 group-hover:pointer-events-auto transition-all duration-200 ease-out">
          <div className="bg-white rounded-xl shadow-xl shadow-blue-900/10 border border-gray-100 p-2 overflow-hidden">
            {item.children?.map((child) => (
              <RouterLink
                key={child.id}
                to={child.path ?? "#"}
                className="block px-4 py-2.5 text-sm font-medium text-gray-600 rounded-lg hover:bg-blue-50 hover:text-blue-600 transition-colors"
              >
                {child.label}
              </RouterLink>
            ))}
          </div>
        </div>
      </li>
    );
  }

  return (
    <li className="px-2 py-2">
      <RouterLink
        to={item.path ?? "#"}
        className="text-[13.5px] font-semibold text-gray-700 hover:text-blue-600 transition-colors relative group"
      >
        {item.label}
        <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-blue-600 transition-all duration-300 group-hover:w-full opacity-0 group-hover:opacity-100" />
      </RouterLink>
    </li>
  );
};

const MobileMenuItem: React.FC<{
  item: NavItem;
  isOpen: boolean;
  onToggle: () => void;
  onTap: () => void;
}> = ({ item, isOpen, onToggle, onTap }) => {
  return (
    <div>
      <button
        onClick={onToggle}
        className="flex items-center justify-between w-full text-2xl font-semibold text-gray-800"
      >
        {item.label}
        <BsChevronDown
          className={`w-5 h-5 transition-transform duration-300 ${
            isOpen ? "rotate-180 text-blue-600" : "text-gray-400"
          }`}
        />
      </button>

      <div
        className={`overflow-hidden transition-all duration-300 ${
          isOpen ? "max-h-96 mt-4" : "max-h-0"
        }`}
      >
        <ul className="pl-4 space-y-3 border-l-2 border-gray-100 ml-1">
          {item.children?.map((child) => (
            <li key={child.id}>
              <RouterLink
                to={child.path ?? "#"}
                className="text-lg font-medium text-gray-600 hover:text-blue-600 block"
                onClick={onTap}
              >
                {child.label}
              </RouterLink>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
};

export default Header;
